var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 363,
    viewBox: "0 0 484 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_8111)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1284_8111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439 286.5C439 395.576 350.576 484 241.5 484C132.424 484 44 395.576 44 286.5C44 177.424 132.424 89 241.5 89C350.576 89 439 177.424 439 286.5Z",
    fill: "#5498EE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.909 279.513L0 139.744V419.257C145.408 503.239 89.8244 471.022 241.909 559V279.513Z",
    fill: "#6C6C6C",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 139.744L241.909 279.513L484.121 139.744L241.909 0C96.627 84.0333 152.464 51.7909 0 139.744Z",
    fill: "#DDDDDD",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.906 279.513V559L484.118 419.257V139.744L241.906 279.513Z",
    fill: "#BFBFBF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.846 478.627C133.178 496.702 148.302 505.428 241.406 559.287V559.866L241.907 559.577L242.409 559.867V559.288L484.368 419.69L484.618 419.545V419.257V140.034L485.122 139.744L484.618 139.453V138.878L484.12 139.166L242.159 -0.433088L241.908 -0.577433L241.658 -0.432813C170.274 40.8569 147.445 54.0748 124.604 67.272C100.959 80.9339 77.3007 94.5735 -0.249847 139.311L-0.5 139.455V139.744V419.257V419.545L-0.25007 419.69C55.9265 452.135 82.1038 467.237 101.846 478.627Z",
    stroke: "black",
    strokeOpacity: 0.05
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1284_8111",
    x: -13,
    y: -13.1549,
    width: 511.122,
    height: 585.889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1284_8111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1284_8111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_8111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484,
    height: 363,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.1c18473d6eece394d43621df218d2b58.svg";
export { ForwardRef as ReactComponent };